export const adAccount = [
  {
    path: "/adAccount/list",
    name: "AccountList",
    component: () => import("@/views/adAccount/list.vue"),
    meta: {
      title: "账号列表",
      icon: "menu_circle",
      activeMenu: "/adAccount/list",
      menuId: "1861283974680621142",
      hidden: false,
    },
  },
  {
    path: "/adAccount/RechargeHistory",
    name: "RechargeHistory",
    component: () => import("@/views/adAccount/RechargeHistory.vue"),
    meta: {
      title: "充值记录",
      icon: "menu_circle",
      activeMenu: "/adAccount/RechargeHistory",
      menuId: "1861283974680621142",
      hidden: false,
    },
  },
  {
    path: "/adAccount/mediaTransferFunds",
    name: "MediaTransferFunds",
    component: () => import("@/views/adAccount/mediaTransferFunds.vue"),
    meta: {
      title: "跨媒体转款",
      icon: "menu_circle",
      activeMenu: "/adAccount/mediaTransferFunds",
      menuId: "1861283974680621142",
      hidden: false,
    },
  },
  {
    path: "/adAccount/zeroClearingHistory",
    name: "ZeroClearingHistory",
    component: () => import("@/views/adAccount/zeroClearingHistory.vue"),
    meta: {
      title: "清零记录",
      icon: "menu_circle",
      activeMenu: "/adAccount/zeroClearingHistory",
      menuId: "1861283974680621142",
      hidden: false,
    },
  },
];
// 按钮code映射
export const productsBtnMap = {
  productExport_76426757: "1861283974676426757", // 商品管理-导出
};
